import React from 'react';
import { UseFieldArrayReturn, UseFormRegister } from 'react-hook-form';
import { PettyCash } from '../../../types';
import Button from '../Button';
import Input from '../Input';
import Select from '../Select';

interface PettyCashExpensesTableProps {
  fields: UseFieldArrayReturn<PettyCash, 'expenses'>['fields'];
  register: UseFormRegister<PettyCash>;
  remove: UseFieldArrayReturn<PettyCash, 'expenses'>['remove'];
  addExpense: () => void;
  classOptions: { value: string; label: string }[];
  categoryOptions: { value: string; label: string }[];
}

const PettyCashExpensesTable: React.FC<PettyCashExpensesTableProps> = ({
  fields,
  register,
  remove,
  addExpense,
  classOptions,
  categoryOptions
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">Expenses - المصروفات</h3>
          <Button
            type="button"
            variant="primary"
            onClick={addExpense}
          >
            Add Expense - إضافة مصروف
          </Button>
        </div>
      </div>
      <div className="card-body">
        {fields.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-300 px-4 py-2 text-center font-semibold">#</th>
                  <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Description - البيان</th>
                  <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Class</th>
                  <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Category - الفرع</th>
                  <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Amount - المبلغ</th>
                  <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, index) => (
                  <tr key={field.id}>
                    <td className="border border-gray-300 px-2 py-1 text-center">
                      <span className="font-medium">{index + 1}</span>
                    </td>
                    <td className="border border-gray-300 px-2 py-1">
                      <Input
                        {...register(`expenses.${index}.description`, { 
                          required: 'Description is required' 
                        })}
                        placeholder="Enter description..."
                        className="w-full"
                      />
                    </td>
                    <td className="border border-gray-300 px-2 py-1">
                      <Select
                        options={classOptions}
                        {...register(`expenses.${index}.class`, { 
                          required: 'Class is required' 
                        })}
                        className="w-full"
                      />
                    </td>
                    <td className="border border-gray-300 px-2 py-1">
                      <Select
                        options={categoryOptions}
                        {...register(`expenses.${index}.category`, { 
                          required: 'Category is required' 
                        })}
                        className="w-full"
                      />
                    </td>
                    <td className="border border-gray-300 px-2 py-1">
                      <Input
                        type="number"
                        step="0.01"
                        {...register(`expenses.${index}.amount`, { 
                          required: 'Amount is required',
                          min: { value: 0.01, message: 'Amount must be greater than 0' }
                        })}
                        placeholder="0.00"
                        className="w-full text-right"
                      />
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-center">
                      <Button
                        type="button"
                        variant="danger"
                        size="sm"
                        onClick={() => remove(index)}
                        className="bg-red-600 hover:bg-red-700 text-white px-2 py-1"
                      >
                        Remove
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <p>No expenses added yet. Click "Add Expense" to start.</p>
            <p className="text-sm">لم يتم إضافة أي مصروفات بعد. اضغط "إضافة مصروف" للبدء.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PettyCashExpensesTable;
